import $ from "jquery";

export default () => {
  $('.js-dropdown-button').on('click', (event) => {
    const $dropdown = $(event.currentTarget).parents('.dropdown');
    $dropdown.toggleClass('is-active');
  });
}
